export default {
  "content": "<path d=\"M3.5 19h4v2h-5l-.103-.005A1 1 0 011.5 20v-5h2v4zM22.5 20a1 1 0 01-1 1h-5v-2h4v-4h2v5zM7.5 15.5h-2v-7h2v7zM11 15.5h-1v-7h1v7zM15 15.5h-2v-7h2v7zM18.5 15.5h-1v-7h1v7zM7.5 5h-4v4h-2V4a1 1 0 011-1h5v2zM21.5 3a1 1 0 011 1v5h-2V5h-4V3h5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};